export class UploadAttachmentsEndpoints {
  listUrl: string;
  downloadUrl: string;
  uploadUrl: string;
  deleteUrl: string;
}
